module.exports = __webpack_public_path__ + "img/icon-close.b0073793.svg";